import React from 'react';

/**
 * Ascend brand mark. Uses the optimized WebP first with PNG fallback for
 * older browsers / email clients. Source files live under /public/brand/.
 *
 * Props:
 *   size  — rendered CSS height in px (width matches; logo is 1:1)
 *   variant — 'auto' (default, picks PNG size that's nearest 2x of `size`)
 *           — 'small' | 'medium' | 'large' (fixed asset, useful for testing)
 *   className — extra utility classes
 */
const _bucket = (size) => {
  // Pick the smallest asset that still gives 2x retina on the rendered size.
  if (size <= 32) return 64;
  if (size <= 64) return 128;
  if (size <= 128) return 256;
  if (size <= 256) return 512;
  return 1024;
};

const Logo = ({ size = 40, alt = 'Ascend', className = '', priority = false, ...rest }) => {
  const asset = _bucket(size);
  const png = `/brand/ascend-logo-${asset}.png`;
  const webp = `/brand/ascend-logo-${asset}.webp`;
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img
        src={png}
        alt={alt}
        width={size}
        height={size}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        // Critical: keep the badge crisp and prevent stretching in flex parents
        style={{ width: size, height: size, objectFit: 'contain' }}
        className={`select-none ${className}`}
        data-testid="ascend-logo"
        {...rest}
      />
    </picture>
  );
};

export default Logo;
